import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInsightIntuition = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15 3.005C21.6274 3.005 27 8.37758 27 15.005C27 21.6324 21.6274 27.005 15 27.005C8.37258 27.005 3 21.6324 3 15.005C3 8.37758 8.37258 3.005 15 3.005Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 15.005H3M27 15.005H29",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.995 1L14.995 3M14.995 27L14.995 29",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.9958 2.87314L20.9958 4.60519M8.99579 25.3898L7.99578 27.1219",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.122 7.99569L25.39 8.99569M4.60537 20.9957L2.87332 21.9957",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.1271 21.9957L25.395 20.9957M4.61041 8.99572L2.87836 7.99572",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.0044 27.1219L21.0044 25.3899M9.00443 4.60525L8.00443 2.8732",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.8877 27.005C20.0915 26.1498 23.7071 21.0862 22.8829 15.6865C22.2235 11.3666 18.3142 8.41943 14.1512 9.10367C10.8208 9.65099 8.54855 12.8962 9.07607 16.352C9.49806 19.1167 12 21.003 14.6643 20.5651C16.7958 20.2147 18.25 18.1378 17.9124 15.9261C17.6423 14.1567 16.0411 12.9495 14.3359 13.2298",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgInsightIntuition;
